import styled from 'styled-components';
import { PlayTextStyles } from '../../../../ui-components/typography/PlayText/PlayText.styles';
import { playFontSize } from '../../../../ui-components/typography/helpers';
import { extraDarkPurple, regularWhite } from '../../../../ui-components/design-tokens';

export const StyledPollQuestion = styled.li`
    ${PlayTextStyles}
    ${playFontSize(1.8)}
        
    display: block;
    width: 100%;
    margin-bottom: 1em;
    background: ${extraDarkPurple};
    border-radius: 10px;
    text-align: center;
`;

export const Link = styled.a`
    display: block;
    color: ${regularWhite};
    padding: 2em 0;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }

    &:hover .play_link-external__icon {
        text-decoration: none;
    }
`;
